<template>
    <div class="search">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-4">
                    <SearchHeader @change="changeSearchStringHandler" :searchString="$store.getters['s']" :loading="loading"/>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <SearchFilters v-if="!pending && $store.getters['total'] > 0" :filters="filtersFromResults"/>
                </div>
                <div class="col-md-8">
                    <SearchPending v-if="pending"/>
                    <template v-if="!pending" aria-live="polite" role="region">
                        <SearchResultsHeader/>
                        <SearchResults :results="results.posts"/>
                        <SearchPagination
                            v-if="$store.getters['total'] > 10"
                            :label="paginationLabels.nav_aria"
                            :before_page_number="paginationLabels.before_page_number"
                            :prev_text="paginationLabels.prev_text"
                            :next_text="paginationLabels.next_text"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchHeader from './components/search-header';
import SearchResults from './components/search-results';
import SearchResultsHeader from './components/search-results-header';
import SearchFilters from './components/search-filters';
import SearchPending from './components/search-pending';
import SearchPagination from './components/search-pagination';
import axios from 'axios';

const { dom_title, nav_aria, before_page_number, prev_text, next_text } = wp_variables.search;
const { rest_api_url } = wp_variables;
const endpoint = 'gutenkit/v1/advanced-search';

export default {
    data () {
        return {
            results: null,
            pending: true,
            loading: false,
            filters: { taxonomies: [], years: [], post_type: [] }
        };
    },

    components: {
        SearchHeader,
        SearchResults,
        SearchResultsHeader,
        SearchFilters,
        SearchPending,
        SearchPagination
    },

    async mounted () {
        const urlParams = window.location.search.split('&');

        const taxonomyRegex = /(\[[a-zA-Z]+\])/;

        this.$store.dispatch('setPage', 1);

        urlParams.forEach((param) => {
            if (param.includes('?s=')) {

                this.$store.dispatch('setS', param.replace('?s=', ''));

            } else if (param.includes('years[')) {

                this.$store.dispatch('addFilter', {
                    type: 'year',
                    slug: param.split('=')[1]
                });

            } else if (param.includes('post_type[')) {

                this.$store.dispatch('addFilter', {
                    type: 'post_type',
                    slug: param.split('=')[1]
                });

            } else if (param.includes('taxonomies[')) {

                let taxonomy = taxonomyRegex.exec(param)[0];
                taxonomy = taxonomy.substring(1, taxonomy.length - 1);
                const slug = param.split('=')[1];

                this.$store.dispatch('addFilter', {
                    type: 'taxonomy',
                    slug, taxonomy
                });
            }
        });

        this.$store.dispatch('addFilter', {
            type: 'lang',
            slug: wp_variables.current_lang
        });
    },

    watch: {
        async query () {
            this.loading = true;
            this.search();
        }
    },

    methods: {

        changeSearchStringHandler (value) {
            this.$store.dispatch('setPage', 1);
            this.$store.dispatch('setS', value);
        },

        async search () {

            this.results = null;
            this.pending = true;
            const q = this.$store.getters['query'];

            const searchUrl = `${rest_api_url}${endpoint}${q}&lang=${wp_variables.current_lang}`;
            const { headers, data } = await axios.get(searchUrl);

            this.$store.dispatch('setHeaders', {
                total: headers['x-wp-total'],
                totalPages: headers['x-wp-totalpages']
            });

            this.pushHistory();

            this.loading = false;

            this.results = data;

            this.pending = false;
        },

        /**
         * Push history and title.
         */
        pushHistory () {
            let title = dom_title;
            if (false !== title.indexOf('%%searchphrase%%')) {
                title = title.replace(new RegExp('%%searchphrase%%', 'g'), this.$store.getters['s']);
            }

            if (false !== title.indexOf('%%page%%') && this.$store.getters['page'] > 1) {
                title = title.replace(new RegExp('%%page%%', 'g'), this.$store.getters['page']);
            } else if (false !== title.indexOf('%%page%%')) {
                title = title.replace(new RegExp(' %%page%%', 'g'), '');
            }

            window.history.pushState({}, title, this.$store.getters['query']);
            document.title = title;
        }
    },
    computed: {
        paginationLabels() {
            return {
                nav_aria,
                before_page_number,
                prev_text,
                next_text
            };
        },

        query () {
            return this.$store.getters['query'];
        },

        filtersFromResults () {
            if (!this.results) return [];

            let filters = [];
            filters.push({ type: 'post_type', ...this.results.post_type });
            filters.push({ type: 'year', ...this.results.years });

            const taxonomies = Object.keys(this.results.taxonomies).map(key => {
                return { type: 'taxonomy', taxonomy: key, ...this.results.taxonomies[key] };
            });

            return [].concat(filters, ...taxonomies);
        }
    },
};
</script>
